/*
 *  Copyright (c) 2011-2024 Acronis International GmbH. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis. See the Acronis Software License Agreement for more information.
 */

// Heavily inspired by https://github.com/angular-translate/bower-angular-translate-interpolation-messageformat
// Designed to be a drop-in replacement for it, but using the IntlMessageFormat library (https://formatjs.github.io/docs/intl-messageformat/)
// instead of the messageformat library

'use strict';

angular.module('pascalprecht.translate')
    .constant('TRANSLATE_MF_INTERPOLATION_CACHE', '$translateMessageFormatInterpolation')
    .factory('$translateMessageFormatInterpolation', [
        '$translateSanitization',
        '$cacheFactory',
        'TRANSLATE_MF_INTERPOLATION_CACHE',
        function ($translateSanitization, $cacheFactory, TRANSLATE_MF_INTERPOLATION_CACHE) {
            const IntlMessageFormat = require('intl-messageformat').default;

            const $translateInterpolator = {};
            const $identifier = 'messageformat';
            let $cache = $cacheFactory.get(TRANSLATE_MF_INTERPOLATION_CACHE);
            let $locale = 'en';

            if (!$cache) {
                $cache = $cacheFactory(TRANSLATE_MF_INTERPOLATION_CACHE);
            }

            $translateInterpolator.setLocale = function (locale) {
                $locale = locale;
            };

            $translateInterpolator.getInterpolationIdentifier = function () {
                return $identifier;
            };

            $translateInterpolator.useSanitizeValueStrategy = function (value) {
                $translateSanitization.useStrategy(value);
                return this;
            };

            $translateInterpolator.interpolate = function (string, interpolationParams) {
                interpolationParams = interpolationParams || {};
                interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params');
                angular.merge(interpolationParams, {strong: function(chunks) {return `<strong>${chunks}</strong>`}});

                let interpolatedText = $cache.get(string + angular.toJson(interpolationParams));

                if (!interpolatedText) {
                    for (let key in interpolationParams) {
                        if (interpolationParams.hasOwnProperty(key)) {
                            let number = parseInt(interpolationParams[key], 10);

                            if (angular.isNumber(number) && ('' + number) === interpolationParams[key]) {
                                interpolationParams[key] = number;
                            }
                        }
                    }

                    interpolatedText = new IntlMessageFormat(string, $locale.replace('_', '-')).format(interpolationParams);
                    interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text');

                    $cache.put(string + angular.toJson(interpolationParams), interpolatedText);
                }

                return interpolatedText;
            };

            return $translateInterpolator;
        }
    ]);
